<template>
  <div class="chartBox">
    <v-chart :options="options" ref="chart" style="width: 100%" />
  </div>
</template>

<script>
export default {
  name: 'financial-chart',
  mounted() {
    window.addEventListener('resize', this.resizeChart)
  },
  data() {
    const options = {
      title: {
        text: '',
        textStyle: {
          fontSize: 15,
        },
      },
      tooltip: {
        trigger: 'axis',
      },
      xAxis: {
        type: 'category',
        data: [],
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          data: [],
          type: 'bar',
        },
      ],
      grid: {
        // top: 40,
        x: 100,
        // x2: 10,
        // y: 100,
      },
    }
    return {
      options: { ...options },
    }
  },
  methods: {
    resizeChart() {
      if (this.$refs.chart) {
        this.$refs.chart.resize()
      }
    },
  },
  props: {
    chartData: {
      type: Object,
      default: () => {},
    },
    field: {
      type: String,
      default: '',
    },
    fieldName: {
      type: String,
      default: '',
    },
  },
  watch: {
    chartData: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const _options = {
          ...this.options,
          title: {
            ...this.options.title,
            text: newValue.fieldName,
          },
          xAxis: {
            ...this.options.xAxis,
            data: newValue && newValue.chartData.map(a => a.year),
          },
          series: [
            {
              ...this.options.series[0],
              data: newValue && newValue.chartData.map(a => a.value),
            },
          ],
        }
        this.options = _options
        this.$refs.chart && this.$refs.chart.refresh()
      },
    },
  },
}
</script>

<style scoped lang="scss">
.chartBox {
  display: inline-block;
  width: 33%;
}
</style>
